/* eslint-disable max-len */
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import RenderApplication from '@/app/modules/contracts/components/application/RenderApplication';
import RenderRank from '@/app/modules/contracts/components/rank/RenderRank';
import RenderBankCode from '@/app/modules/contracts/components/bankCode/RenderBankCode';
import payluddSubscriptionFields from '../../../fields/payluddSubscriptionFields';


export const columnsEmergencyContractsId = 'emergency_contracts';

export const columnsEmergencyContracts = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsEmergencyContractsId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT.PROFILES.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderApplication applicationCode={cell.getValue(payluddSubscriptionFields.CONTRACT.PROFILES.APPLICATION.key)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT.PROFILES.NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT.PROFILES.RANK,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderRank rank={cell.getValue(payluddSubscriptionFields.CONTRACT.PROFILES.RANK.key)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT.PROFILES.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(payluddSubscriptionFields.CONTRACT.PROFILES.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT.PROFILES.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        })
    ]).filter(col => !!col);
};